import { CITATIONS_SHOW_ALL } from '../classnames/scientific-citations';
import { HIDDEN } from '../classnames/design-system';
import CitationLinksContainer from './citation-links-container';

const CITATIONS_DISPLAYED_WHEN_COLLAPSED = 4;

export default class ShowAllButton {
  constructor({ count }) {
    this.count = count;
  }

  showAllButton = document.querySelector(`.${CITATIONS_SHOW_ALL}`);

  getLinkText = () => `View all ${this.count} citations`;

  onClick = (event) => {
    event.preventDefault();
    (new CitationLinksContainer()).expand();
  };

  render = () => {
    if (this.count > CITATIONS_DISPLAYED_WHEN_COLLAPSED) {
      this.showAllButton.addEventListener('click', this.onClick);
      this.showAllButton.innerHTML = this.getLinkText();
      this.showAllButton.classList.remove(HIDDEN);
    }
  };
}
